export default "__VITE_ASSET__BIy$55lt__"